module.exports = __webpack_public_path__ + "static/media/bi.8951ab33.svg";